import React, { useState, useEffect, useMemo } from 'react';
import { b as breakpoints, r as reactResponsive } from './breakpoints-9c323f1e.js';
import PropTypes from 'prop-types';
import './_commonjsHelpers-615a4363.js';
import './_variables.es6-7ae4f1ec.js';

/**
 *
 * Used to give a fallback breakpoint for all responsive components
 * specifically for SSR
 */
function ResponsiveProvider({
  fallbackBreakpoint,
  children
}) {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    setInitialized(true);
  }, []);
  const settings = useMemo(() => ({
    width: breakpoints[fallbackBreakpoint].min || breakpoints[fallbackBreakpoint].max
  }), [fallbackBreakpoint]);
  return initialized ? children : /*#__PURE__*/React.createElement(reactResponsive.exports.Context.Provider, {
    value: settings
  }, children);
}
ResponsiveProvider.propTypes = {
  /** fallback breakpoint to use if one can't be determined, especially in SSR */
  fallbackBreakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']).isRequired
};

export { ResponsiveProvider as default };
